export default __webpack_public_path__ + "static/media/CNo.63-1.ef52e291.jpg";